<template>
  <div class="main_profile_wrapper">
    <div class="main_table">
      <TableHeaderSection
      v-if="hasPermission('create group_cards')"
        :title="`${localization('Data Cards')}`"
        :text="`${localization('Browse groups of data cards.')}`"
        :buttonText="`${localization('Create new group')}`"
        :total="totalDataCards"
        @toggleModal="createGroup"
      ></TableHeaderSection>
      <div class="header_container just_custom_table_tasks">
        <CustomTable
          :count="totalDataCards"
          :DataItems="dataCards"
          @Refresh="Refresh"
          @reset="filter = {}"
          :filter="filter"
          :title="`${localization('Data Cards')}`"
          hidden_export_import
          @reset-filters="filter = {}"
          viewName="DataCards"
        >
          <template #columns>
            <el-table-column prop="name" :label="`${localization('Name')}`">
              <template #default="{ row }">
                <div class="pl-2">
                  {{ row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="description" :label="`${localization('Description')}`">
              <template #default="{ row }">
                <div class="pl-2">
                  {{ row.description }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="actions" width="150">
            <template slot-scope="scope">
              <div class="td-actions"  >
                <span   >
                    <a
                      v-if="hasPermission('view group_cards')"
                      v-tooltip.top-center="`${localization('Show')}`"
                      class="btn btn-info btn-link btn-xs"
                      @click="showGroup(scope.row.id)"
                    >
                      <i class="fa fa-eye text-dark"></i
                    >
                    </a>
                    <a
                      v-if="hasPermission('delete group_cards')"
                      v-tooltip.top-center="`${localization('Delete')}`"
                      @click="deleteGroup(scope.row.id)"
                    >
                      <img
                        role="button"
                        src="@/assets/new-theme/delete-button-table.png"
                        alt="delete"
                      />
                    </a>
                </span>
              </div>
            </template>
             </el-table-column>
          </template>
        </CustomTable>
      </div>
    </div>

    <!-- Create Group Modal -->
    <el-dialog
      @close="resetForm"
      :title="localization('Create new group')"
      :visible.sync="dialogVisible"
      width="800px"
      top="1%"
      custom-class="task-modal global_modal"
      :close-on-click-modal="true"
    >
      <div class="custom_modal_header">
        <div class="images">
           <img src="@/assets/new-theme/icons/users-plus.png" alt="file" />
          <img
            @click="resetForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title font-weight-bold mt-3">
          {{ localization("Create new group") }}
        </h3>
        <p class="description">
          {{ localization("Enter the group name and description.") }}
        </p>
      </div>
      <el-form
        :rules="rules"
        ref="addGroupForm"
        :model="form"
        @submit.native.prevent
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="`${localization('Name')}`"
              prop="name"
            >
              <el-input
                :placeholder="`${localization('Enter group name')}`"
                v-model="form.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="`${localization('Topics')}`"
              prop="topics_card_id"
            >
              <el-select
                v-model="form.topics_card_id"
                filterable
                class="w-100"
                :placeholder="`${localization('Select Topic')}`"
              >
                <el-option
                  v-for="item in topicsCardLookups"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="`${localization('School Average Score')}`"
              prop="school_avg_score"
            >
              <el-input
                type="number"
                :placeholder="`${localization('Enter school avg score')}`"
                v-model="form.school_avg_score"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="`${localization('District Average Score')}`"
              prop="district_avg_score"
            >
              <el-input
                type="number"
                :placeholder="`${localization('Enter district avg score')}`"
                v-model="form.district_avg_score"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="`${localization('State Average Score')}`"
              prop="state_avg_score"
            >
              <el-input
                type="number"
                :placeholder="`${localization('Enter state avg score')}`"
                v-model="form.state_avg_score"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="`${localization('School Grade')}`"
              prop="school_grade"
            >
              <el-select
                v-model="form.school_grade"
                class="w-100"
                :placeholder="`${localization('Select School Grade')}`"
              >
                <el-option
                  v-for="grade in ['1', '2', '3', '4']"
                  :key="grade"
                  :label="grade"
                  :value="grade"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
           <el-col :span="24">
            <el-form-item
              :label="`${localization('Description')}`"
              prop="description"
            >
              <el-input
                type="textarea"
                :placeholder="`${localization('Enter group description')}`"
                v-model="form.description"
              ></el-input>
            </el-form-item>
           </el-col>
        </el-row>

      </el-form>
      <div class="lci_modal_buttons mt-5">
        <button @click="resetForm" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm" class="lci_btn save lci_btn_modal_cancel">
          {{ localization("Create") }}
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "DataCardsIndex",
  data() {
    return {
      filter: {},
      dialogVisible: false,
      form: {
        name: "",
        description: "",
        topics_card_id: null,
        school_avg_score: "",
        district_avg_score: "",
        state_avg_score: "",
        school_grade: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      dataCards: ["data_cards/dataCards"],
      totalDataCards: ["data_cards/totalDataCards"],
      loading: ["data_cards/loading"],
    }),
    ...mapGetters("topics_card", ["topicsCardLookups"]),
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        topics_card_id: [
          {
            required: true,
            message: this.localization("Please select a topic"),
            trigger: "change"
          }
        ],
        school_avg_score: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        district_avg_score: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        state_avg_score: [
          {
            required: true,
            message: this.localization("Please this field is required"),
            trigger: "blur"
          }
        ],
        school_grade: [
          {
            required: true,
            message: this.localization("Please select a grade"),
            trigger: "change"
          }
        ]
      };
    }
  },
  methods: {
    Refresh(query) {
      this.$store.dispatch("data_cards/GetDataCards", { query: query });
    },
    createGroup() {
      this.dialogVisible = true;
    },
    resetForm() {
      this.form = {
        name: "",
        description: "",
        topics_card_id: null,
        school_avg_score: "",
        district_avg_score: "",
        state_avg_score: "",
        school_grade: ""
      };
      this.dialogVisible = false;
    },
    showGroup(id) {
      this.$router.push({ name: "Data Card Details", params: { id: id } });
    },
    submitForm() {
      this.$refs.addGroupForm.validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("data_cards/CreateDataCard", this.form)
            .then(() => {
              this.resetForm();
              Swal.fire({
                title: "",
                icon: "success",
                text: `${this.localization("Done")}`,
                confirmButtonText: `${this.localization("Ok")}`,
                type: "success",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false,
              });
              this.Refresh();
            })
            .catch(() => {
              // Handle error if needed
            });
        }
      });
    },
    deleteGroup(id) {
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch("data_cards/DeleteDataCard", id).then(() => {
            this.Refresh();
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Deleted")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
          });
        }
      });
    }
  },
  mounted() {
    this.Refresh({});
    this.$store.dispatch("topics_card/GetTopicsCardLookups");
  },
};
</script>

<style lang="scss" scoped>
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 0 30px 50px;
}
.main_table {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid #eaecf0;

  .head_table {
    border-bottom: 1px solid #eaecf0;
  }
}

/* Modal Styles reused/adapted from Groups */
.lci_modal_buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3%;
  .lci_btn_modal_cancel {
    background-color: #fff;
    color: #667085;
    border-radius: 8px;
    padding: 12px 20px;
    border: 1px solid #eaecf0;
    width: calc(97% / 2);
    &.save {
      background-color: #7f56d9;
      color: #fff;
    }
  }
}
</style>
